
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import ImpferinnerungstexteDetail from '@/components/Impferinnerungstexte/ImpferinnerungstexteDetail.vue';
    import Impferinnerungstext from '@/types/Impferinnerungstext';
    import { ImpferinnerungstexteFilter, LoadImpferinnerungstextePayload } from '@/store/impferinnerungstexte';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            ImpferinnerungstexteDetail,
        },
        computed: {
            ...mapState('impferinnerungstexte', ['impferinnerungstexte', 'dialogs', 'loaders']),
            ...mapGetters('authentication', ['isAllowed']),
        },
        methods: {
            ...mapActions('impferinnerungstexte', ['loadImpferinnerungstexte']),
            ...mapMutations('impferinnerungstexte', ['setDialogsDetail']),
        },
    })
    export default class Impferinnerungstexte extends Vue {
        public loadImpferinnerungstexte!: (payload?: LoadImpferinnerungstextePayload) => void;
        public setDialogsDetail!: (visible: boolean) => void;

        public impferinnerungstext = new Impferinnerungstext();
        public search = '';

        public filter: ImpferinnerungstexteFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Impferinnerungstext> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Bezeichnung', value: 'bezeichnung' },
                /*{ text: 'Verabreichung', value: 'verabreichung' },*/
                { text: 'Gültig', value: 'gueltig' },
            ];
        }

        public mounted(): void {
            this.loadImpferinnerungstexte();
        }

        public onChangeFilter(): void {
            this.loadImpferinnerungstexte({ filter: this.filter });
        }

        public onClickEdit(impferinnerungstext: Impferinnerungstext): void {
            this.impferinnerungstext = new Impferinnerungstext(impferinnerungstext);
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.impferinnerungstext = new Impferinnerungstext();
            this.setDialogsDetail(true);
        }
    }
